import './strict.css';
import './global.css';

import { HelmetProvider } from '@dr.pogodin/react-helmet';
import * as Sentry from '@sentry/browser';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import AppLoader from './AppLoader';
import { APP_ENV } from './config';

if (APP_ENV !== 'dev') {
  Sentry.init({
    dsn: 'https://1a5fe0f291334564996dbf94986183a3@sentry.io/1431769',
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element not found');

const root = createRoot(rootElement);
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AppLoader />
    </BrowserRouter>
  </HelmetProvider>
);
